<template>
  <div>
    <div class="choose">
      <van-cell-group>
        <!-- 学年 -->
        <van-field label="学年"
                   @click="isYearShow=true"
                   placeholder="请选择学年"
                   readonly
                   v-model='selectYear' />
        <!-- 学期 -->
        <van-field label="学期"
                   @click="isSessionShow=true"
                   placeholder="请选择学期"
                   readonly
                   v-model='selectSession' />
      </van-cell-group>
      <van-action-sheet v-model="isYearShow"
                        :actions="yearData"
                        @select="yearSelectFun"
                        cancel-text="取消"
                        close-on-click-action />
      <van-action-sheet v-model="isSessionShow"
                        :actions="sessionData"
                        @select="sessionSelectFun"
                        cancel-text="取消"
                        close-on-click-action />
    </div>
    <div class="my-report">总分：{{data.Score}}</div>
  </div>
</template>
<script>
export default {
  name: 'MyReport',
  components: {},
  data () {
    return {
      data: [],
      //学年
      isYearShow: false,
      selectYear: "",
      selectYearId: 0,
      yearData: [],
      //学期
      isSessionShow: false,
      selectSession: "",
      selectSessionId: 0,
      sessionData: []
    }
  },
  created () {
    this.getYear();
  },
  mounted () {
  },
  methods: {
    //获取学年
    async getYear () {
      this.xy.loading();
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/YearList`);
      this.xy.unloading();
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            if (item.IsCurrent) {
              this.selectYearId = item.ID;
              this.selectYear = item.Name;
              this.getSession(item.ID);
            }
            this.yearData.push({
              id: item.ID,
              name: item.Name
            });
          });
        }
      }
    },
    //获取学期
    async getSession (id) {
      this.xy.loading();
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/SessionList`, {
        yearID: id
      });
      this.xy.unloading();
      if (res.success) {
        this.selectSession = "";
        this.selectSessionId = 0;
        this.sessionData = [];
        res.data.map(item => {
          if (item.IsCurrent) {
            this.selectSessionId = item.AcademicSessionID;
            this.selectSession = item.AcademicSessionName;
            this.onLoad();
          }
          this.sessionData.push({
            id: item.AcademicSessionID,
            name: item.AcademicSessionName
          });
        });
      }
    },
    //选中学年
    yearSelectFun (e) {
      this.selectYear = e.name;
      this.selectYearId = e.id;
      //学期重置
      this.getSession(e.id);
    },
    // 选中学期
    sessionSelectFun (e) {
      this.selectSession = e.name;
      this.selectSessionId = e.id;
      this.onLoad();
    },
    //我的报告
    async onLoad () {
      this.xy.loading();
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/MyEva/GetMyEVA`, {
        sessionID: this.selectSessionId
      });
      this.xy.unloading();
      if (res.success) {
        this.data = res.data;
      }
    },
  }
}
</script>
<style lang="less" scoped>
.van-cell-group {
  display: flex !important;
  /deep/ .van-field__label {
    width: auto !important;
    margin-right: 20px !important;
    span {
      font-size: 28px !important;
    }
  }
  /deep/ .van-field__body {
    input {
      font-size: 28px;
    }
  }
}
.my-report {
  min-height: 500px;
  padding: 25px;
  background: #fff;
}
</style>